import "esbuild-css-modules-plugin-ns-css:src/artifacts/shared/styles/icon/error.module.css";

export default {
  "animateErrorIcon": "error-module__animateErrorIcon_O-opYq__010",
  "animateXMark": "error-module__animateXMark_O-opYq__010",
  "icon": "error-module__icon_O-opYq__010",
  "line": "error-module__line_O-opYq__010",
  "lineLeft": "error-module__lineLeft_O-opYq__010",
  "lineRight": "error-module__lineRight_O-opYq__010",
  "xMark": "error-module__xMark_O-opYq__010"
};
      